import { Autocomplete, FormHelperText, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'

interface ICountry {
  id: number
  name: string
}

function CountryMultiAutocomplete({ value, handleInputChange }: any) {
  const { t } = useTranslation(['global'])
  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)
  const { countries } = useSelector((state: IRootState) => state.country)

  const handleMultiAutoCompleteChange = (countries: ICountry[]) => {
    let optionsMulti: number[] = []
    if (countries !== null) {
      for (let i = 0; i < countries.length; i++) {
        optionsMulti.push(countries[i].id)
      }
    }

    handleInputChange('countries', optionsMulti)
  }

  return (
    <>
      <Autocomplete
        id="multi-autocomplete-countries"
        value={countries.filter((country: any) => value.includes(country.id))}
        onChange={(_, value) => handleMultiAutoCompleteChange(value)}
        options={countries}
        multiple
        fullWidth
        getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
        renderInput={params => (
          <TextField required {...params} label={t('country')} error={errorForm.countries} variant="filled" InputLabelProps={{ shrink: true }} />
        )}
      />
      <FormHelperText error={errorForm.countries}>{msgForm.countries}</FormHelperText>
    </>
  )
}

export default CountryMultiAutocomplete
